<template>
  <div class="searchInput">
    <UiInputText v-bind="$attrs" placeholder="Поиск" type="text" v-on="listeners" />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

import UiInputText from '@/components/UiInputText.vue'

export default {
  components: {
    UiInputText,
  },
  inheritAttrs: false,
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: debounce((value) => this.$emit('input', value), 400),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.searchInput {
  width: 100%;
  margin: 0 0 20px 0;

  @include media_tablet() {
    width: 300px;
  }
}
</style>
